import * as msal from "@azure/msal-browser";

export const msalConfig = {
    auth: {
      clientId: '07b7516b-6544-451a-9dd6-c8fc7f857340',
      authority: 'https://login.microsoftonline.com/c1e5a355-9690-47b4-8d12-00ef54493edb',
      // redirectUri: 'https://elitebamhr.in'
      redirectUri: 'https://gwfs-sao.nipponexpress.com'
    },
    cache:{
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                console.log(`[MSAL] ${message}`);
            },
            piiLoggingEnabled: false,
            logLevel: msal.LogLevel.Info,
        }
    }
  };

  export const loginRequest = {
    scopes: [ "openid",
              "profile",
              // "api://ab0877b7-0d91-41b6-a8d2-3fef12292423/.default",
              "api://0cf67298-8c3a-417b-81bf-4dc5ad9df0be/user.read", 
              "api://0cf67298-8c3a-417b-81bf-4dc5ad9df0be/access_as_nx_user",
              "User.Read"]
  };


// export const msalConfig = {
//     auth: {
//       clientId: '8b1b0684-ab2b-4037-a6e0-de9e23f865a0',
//       authority: 'https://login.microsoftonline.com/c1e5a355-9690-47b4-8d12-00ef54493edb',
//       // redirectUri: 'https://elitebamhr.in'
//       redirectUri: 'https://localhost:3000/'
//     },
//     cache:{
//       cacheLocation: "localStorage",
//       storeAuthStateInCookie: false,
//     },
//      system: {
//         loggerOptions: {
//             loggerCallback: (level, message, containsPii) => {
//                 console.log(`[MSAL] ${message}`);
//             },
//             piiLoggingEnabled: false,
//             logLevel: msal.LogLevel.Info,
//         }
//     }
//   };
 
//   export const loginRequest = {
//     scopes: [ "openid",
//               "profile",
//               // "api://ab0877b7-0d91-41b6-a8d2-3fef12292423/.default",
//               "api://92f72945-cafa-4d09-9323-38e0ad83222b/user.read",
//               "api://92f72945-cafa-4d09-9323-38e0ad83222b/access_as_nx_user",
//               "User.Read"]
//   };
 